import { Box, Text, VStack } from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";

const SideBottomLinks = () => {
  const router = useRouter();

  // Routing function, just pass in the pathname e.g "/, /discover etc"
  const goTo = (loc: string) => {
    router.push(loc);
  };

  return (
    <Box fontSize="sm" mt="auto" mb={12}>
      <VStack spacing={6} align="stretch">
        {/* Back to home */}
        <Link passHref href="/">
          <Text as="a" cursor="pointer" color="blue.500" my="auto" fontWeight={700}>
            Back to Home
          </Text>
        </Link>

        {/* Our story */}
        {/* <Flex cursor="pointer" onClick={() => goTo('/')} color="gray.500" fontWeight={700}>
					<Text>Our Story</Text>

					<Text my="auto">
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M6.76506 11.7049C6.34253 12.1274 6.34256 12.8125 6.76511 13.235C7.18765 13.6575 7.87268 13.6575 8.29519 13.235L13.836 7.69398V11.5731C13.836 12.1706 14.3204 12.6551 14.918 12.6551C15.5156 12.6551 16 12.1706 16 11.5731V4H8.42588C7.82837 4 7.34399 4.48438 7.34399 5.08188C7.34399 5.67939 7.82837 6.16377 8.42588 6.16377H12.3059L6.76506 11.7049Z"
								fill="currentColor"
							/>
						</svg>
					</Text>
				</Flex> */}

        {/* Plans */}
        {/* <Flex cursor="pointer" onClick={() => goTo('/')} color="gray.500" fontWeight={700}>
					<Text>Plans</Text>

					<Text my="auto">
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M6.76506 11.7049C6.34253 12.1274 6.34256 12.8125 6.76511 13.235C7.18765 13.6575 7.87268 13.6575 8.29519 13.235L13.836 7.69398V11.5731C13.836 12.1706 14.3204 12.6551 14.918 12.6551C15.5156 12.6551 16 12.1706 16 11.5731V4H8.42588C7.82837 4 7.34399 4.48438 7.34399 5.08188C7.34399 5.67939 7.82837 6.16377 8.42588 6.16377H12.3059L6.76506 11.7049Z"
								fill="currentColor"
							/>
						</svg>
					</Text>
				</Flex> */}
      </VStack>

      {/* Copyright */}
      {/* <Box mt={10} mb={2}>
        <Copyright />
      </Box> */}
    </Box>
  );
};

export default SideBottomLinks;
